module.exports = __webpack_public_path__ + "assets/img/0806.c972d156.png";